module.exports = __webpack_public_path__ + "img/166.restaurant_complex_cleaning.5813071c.svg";